import React, { useState, useEffect } from 'react';
import { checkAdmin, getPassCode, checkApiError } from '../utils';
import ImagesAll from '../assets';
import { useNavigate } from 'react-router-dom';
import './../css/dashboard.css';

const Dashboard = ({showLoading}) => {
  const [totalCabMembers, setTotalCabMembers] = useState(0);
  const [totalEncoraMembers, setTotalEncoraMembers] = useState(0);
  const [totalUpcomingEvents, setTotalUpcomingEvents] = useState(0);
  const isAdmin = checkAdmin();
  const navigate = useNavigate();

  const [upcomingEvnets, setUpcomingEvnets] = useState([]);

  useEffect(() => {
      if(getPassCode() === ""){
        navigate("/login");
      }
      showLoading(true);
       const fetchTotalMembers = async () => {
          try {
              const response = await fetch(`${process.env.REACT_APP_API_URL}/DashBoard/getdashboarddetails`, {
                  method: 'get',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${getPassCode()}`
                  }
              });
          
              if(checkApiError(response.status)){ navigate("/login"); return; }

              if (response.status === 200) {
                  const data = await response.json();
                  setTotalCabMembers(data.dashboardDetails.cabMembers);
                  setTotalEncoraMembers(data.dashboardDetails.encoraLeaders);
                  setTotalUpcomingEvents(data.dashboardDetails.upcomingEvents);
              } else {
                setTotalCabMembers(0);
                setTotalEncoraMembers(0);
                setTotalUpcomingEvents(0);
              }
          } catch (error) {
              console.log(error);
          }
        };        

        const fetchUpcomingEvents = async () => {
          try {
              const response = await fetch(`${process.env.REACT_APP_API_URL}/DashBoard/getupcomingeventsdetails`, {
                  method: 'get',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${getPassCode()}`
                  }
              });

              if(checkApiError(response.status)){ navigate("/login"); return; }
          
              if (response.status === 200) {
                  const data = await response.json();
                  setUpcomingEvnets(data.upcomingEventDetails);
              } else {
                setUpcomingEvnets([]);
              }
          } catch (error) {
              console.log(error);
          }finally{
            showLoading(false);
          }
        };
        
        fetchTotalMembers();
        fetchUpcomingEvents();
    }, [navigate, showLoading]);

  const handleUserManagementClick = () => {
    // Navigate to the User Management page
    navigate('/user-management'); // Replace '/user-management' with the actual route
  };

  const handleEventManagementClick = () => {
    // Navigate to the Event Management page
    navigate('/event-management'); // Replace '/event-management' with the actual route
  };
  
  const handleViewEvent = (_event) => {
    // Navigate to the event view page page
    const eventLive = _event.eventType.toLowerCase() === 'live';
    navigate('/Home', {state: {eventIsLive: eventLive, eventId: _event.eventId}}); 
  };

  const formatDate = (dateString) => { 
    const date = new Date(dateString);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('EN-US', options); 
  };

  return (
    <div className="dashboard w3-container mt-4 mb-4">
      <p className="roboto-bold mb-3 color-black t-h">Dashboard</p>
      <div className="row top-panel">
        <div className="card-mobile col-md-4 col-sm-6">
          <div className="card mb-4 bb-blue">
            <div className="card-body text-center d-flex justify-content-around align-items-center">
              <img src={ImagesAll.CABMembers} alt="CAB Members" className="" />
              <h5 className="card-title m-0">CAB Members</h5>
              <p className="card-text display-4 fw-500 color-gray">{totalCabMembers}</p>
            </div>
          </div>
        </div>

        <div className="card-mobile col-md-4 col-sm-6">
          <div className="card mb-4 bb-orange">
            <div className="card-body text-center d-flex justify-content-around align-items-center">
              <img src={ImagesAll.CABLeaders} alt="Encora Leaders" className="" />
              <h5 className="card-title m-0">Encora Leaders</h5>
              <p className="card-text display-4 fw-500 color-gray">{totalEncoraMembers}</p>
            </div>
          </div>
        </div>

        <div className="card-mobile col-md-4 col-sm-6">
          <div className="card mb-4 bb-brown">
            <div className="card-body text-center d-flex justify-content-around align-items-center">
              <img src={ImagesAll.UpcomingEvents} alt="My Events" className="" />
              <h5 className="card-title m-0" style={{maxWidth: "180px"}}>Upcoming/ Ongoing Events</h5>
              <p className="card-text display-4 fw-500 color-gray">{totalUpcomingEvents}</p>
            </div>
          </div>
        </div>
      </div>

      <div className='row middle-panel'>
        <p className='upcoming-events roboto-bold s-h'>Upcoming/ Ongoing Events</p>
      </div>

      { upcomingEvnets.length > 0 ? (
        upcomingEvnets.map(event => (
          <div className='row middle-panel' key={event.eventId}>
            <div className="col-md-12 col-sm-12">
              <div className={`card mb-4`}>
                <div className="card-body">
                  <div className={`event-status ${event.eventStatus.toLowerCase()}`}>
                    <span></span>
                    <span>{event.eventStatus}</span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center'>
                    <ul className='color-purple events fw-500'>
                      <li className='w-26-p'><span className='color-gray fw-normal me-1'>Event Name:</span> <span>{event.eventTitle}</span></li>
                      <li className='d-line color-gray'>|</li>
                      <li className='w-16-p'><span className='color-gray fw-normal me-1'>Event Type:</span> <span>{event.eventType}</span></li>
                      <li className='d-line'>|</li>
                      <li className='w-16-p'><span className='color-gray fw-normal me-1'>Coordinator:</span> <span>{event.eventCoordinator}</span></li>
                      <li className='d-line'>|</li>
                      <li className='w-22-p'>
                        <div>
                          <div>
                            <span className='color-gray fw-normal me-1'>Start Date:</span> 
                            <span>{formatDate(event.eventStartDate)}</span>
                          </div>
                          <div>
                            <span className='color-gray fw-normal me-1'>End Date:</span> 
                            <span>{formatDate(event.eventEndDate)}</span>
                          </div>
                        </div>
                      </li>
                      <li><button type="button" className="btn btn-purple btn-sm btn-view-event" onClick={()=>{handleViewEvent(event)}}>View Event</button></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className='row middle-panel'>
          <p className=''>No Upcoming/Ongoing Events</p>
        </div>
      )}

      {isAdmin && (
        <div className='row bottom-panel'>
          {/* User Management Card */}
          <div className="col-md-6">
            <div className="card mb-4">
              <div className="card-body text-center d-flex justify-content-around align-items-center">
                <div>
                  <img src={ImagesAll.ManageAttendee} alt="User Management" className='user-management-icon' /> 
                </div>
                <p className="card-title m-0 display-6 fw-lighter">
                  <span className='text-start'>Manage<br/> Members</span>
                </p>
                <button type="button" className="btn  btn-gray btn-manage" onClick={handleUserManagementClick}>&#8594;</button>
              </div>
            </div>
          </div>

          {/* Event Management Card */}
          <div className="col-md-6">
            <div className="card mb-4">
              <div className="card-body text-center d-flex justify-content-around align-items-center">
                <div>
                  <img src={ImagesAll.ManageEvent} alt="Event Management" className='event-management-icon' />
                </div>
                <p className="card-title m-0 display-6 fw-lighter"><span className='text-start'>Manage<br/> Events</span></p>
                <button type="button" className="btn  btn-gray btn-manage" onClick={handleEventManagementClick}>&#8594;</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;

